<template>
  <div class="container-fluid mt-3">
    <!--     <h4 class="ml-3 mt-3">Permissions</h4>
 -->
    <b-row class="">
      <b-col>
        <UserSelect @user-select="setUserSelect($event)" />
      </b-col>
      <b-col>
        <b-button
          v-if="userHasPermission('permissions', 'write')"
          @click="updatePermissions()"
          :disabled="permissionsStatus === 'fetching'"
          >Update permissions</b-button
        ></b-col
      >
    </b-row>
    <div class="pt-4">
      <div class="">
        <b-table
          show-empty
          bordered
          small
          stacked="md"
          head-variant="light"
          :items="permissionsFormatted"
          :fields="fields"
          :busy="permissionsStatus === 'fetching'"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" variant="yellow" />
            </div>
          </template>
          <template #cell(read)="{ item }">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                :checked="item.read ? true : false"
                @change="(val) => onRowSelected(val, item, 'read')"
              />
            </div>
          </template>
          <template #cell(write)="{ item }">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                :checked="item.write ? true : false"
                @change="(val) => onRowSelected(val, item, 'write')"
              />
            </div>
          </template>
        </b-table>
        <!--      <b-pagination
          align="end"
          :value="permissions.data.currentPage"
          :total-rows="permissions.data.total"
          :per-page="permissions.data.perPage"
          class="mb-2"
          @change="changePage"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { generalMixin } from "../../mixin";
import { superAdminMixin } from "../mixins";
import { GET_PERMISSIONS, POST_USER_PERMISSIONS } from "./actions";
import UserSelect from "./UserSelect.vue";
export default {
  components: {
    UserSelect,
  },
  mixins: [generalMixin, superAdminMixin],
  computed: {
    ...mapState({
      permissions: (state) =>
        state.superAdminStore.permissions.permissionsList.data,
      permissionsStatus: (state) =>
        state.superAdminStore.permissions.permissionsList.status,
    }),
    permissionsFormatted() {
      return this.permissionsList;
    },
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "write", label: "Write" },
        { key: "read", label: "Read" },
      ],
      userSelected: null,
      permissionsList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$store
        .dispatch(GET_PERMISSIONS)
        .then(() => {
          this.permissionsList = this.formatPermissions();
          this.$children[0].getUsersPermission();
          this.resetPermissions();
          this.userSelected = null;
          this.$children[0].clearUserSelect();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setUserSelect(user) {
      this.userSelected = user;
      this.permissionsList = [...this.permissions];
      this.resetPermissions();
      this.setPermissionsByUser();
      /*    this.$store
        .dispatch(GET_PERMISSIONS, { userId: user.id })
        .then(() => {})
        .catch(() => {}); */
    },
    onRowSelected(val, item, action) {
      if (action === "read") {
        item.read = val;
      } else if (action === "write") {
        item.write = val;
        if (item.write == true && item.read == false) {
          item.read = true;
        }
      }
      const index = this.permissionsList.findIndex(
        (permission) => permission.module === item.module
      );
      this.permissionsList[index] = item;
    },
    formatPermissions() {
      this.permissionsList = [];
      let permissionsList = [...this.permissions];
      permissionsList.forEach((permission) => {
        permission.read = false;
        permission.write = false;
      });
      return permissionsList;
    },
    setPermissionsByUser() {
      this.permissionsList.forEach((permission) => {
        const index = this.userSelected.listPermissions.findIndex(
          (userPermission) => userPermission.module === permission.module
        );
        if (index !== -1) {
          permission.read =
            this.userSelected.listPermissions[index].read == 1 ? true : false;
          permission.write =
            this.userSelected.listPermissions[index].write == 1 ? true : false;
        }
      });
      this.permissionsList = [...this.permissionsList];
    },
    resetPermissions() {
      this.permissionsList.forEach((permission) => {
        permission.read = false;
        permission.write = false;
      });
      this.permissionsList = [...this.permissionsList];
    },
    updatePermissions() {
      this.$store
        .dispatch(POST_USER_PERMISSIONS, {
          userId: this.userSelected.id,
          permissions: this.permissionsList,
        })
        .then(() => {
          this.makeToast("Success", "Permissions updated", "success");
          this.getData();
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>